import { Logout } from '@mui/icons-material'
import {
    alpha,
    AppBar,
    Box,
    IconButton,
    Stack,
    Toolbar,
    Tooltip,
    useTheme,
} from '@mui/material'
import { Link, NavLink } from 'react-router-dom'
import { recruiterRouteConfig } from 'recruiter/routes'
import useIsMobile from 'shared/hooks/useIsMobile'
import { getPxAsRem } from 'shared/utils'
import WhiteLogo from './WhiteLogo'

export interface TopNavigationProps {
    links: { label: string; path: string }[]
    centerContent?: React.ReactNode
}

export function TopNavigation({ links, centerContent }: TopNavigationProps) {
    const theme = useTheme()
    const isMobile = useIsMobile()

    return (
        <AppBar position="static" sx={{ backgroundColor: 'primary.dark' }}>
            <Toolbar disableGutters sx={{ paddingX: getPxAsRem(16) }}>
                <Box
                    component={Link}
                    to={isMobile ? recruiterRouteConfig.candidates.path : '/'}
                    sx={{ display: 'flex', padding: getPxAsRem(4) }}
                >
                    <WhiteLogo />
                </Box>

                {!isMobile && (
                    <Stack
                        component="nav"
                        direction="row"
                        spacing={getPxAsRem(8)}
                        marginLeft={getPxAsRem(8)}
                    >
                        {links.map((link) => (
                            <Box
                                key={link.label}
                                component={NavLink}
                                to={link.path}
                                sx={(theme) => ({
                                    color: 'white',
                                    padding: getPxAsRem(6, 10),
                                    borderRadius: getPxAsRem(8),
                                    textDecoration: 'none',
                                    transition:
                                        'background-color 250ms, color 250ms',

                                    '&:hover': {
                                        backgroundColor: alpha(
                                            theme.palette.primary.light,
                                            0.25
                                        ),
                                    },

                                    '&.active': {
                                        backgroundColor:
                                            theme.palette.primary.light,
                                        color: theme.palette.primary.main,
                                    },
                                })}
                            >
                                {link.label}
                            </Box>
                        ))}
                    </Stack>
                )}

                {centerContent && (
                    <Box
                        sx={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'center',
                            paddingX: getPxAsRem(16),
                        }}
                    >
                        {centerContent}
                    </Box>
                )}

                <Stack
                    direction="row"
                    spacing={getPxAsRem(4)}
                    marginLeft={centerContent ? 0 : 'auto'}
                >
                    <Tooltip title="Log Out">
                        <IconButton
                            component={Link}
                            to="/logout"
                            sx={{ color: theme.palette.common.white }}
                        >
                            <Logout />
                        </IconButton>
                    </Tooltip>
                </Stack>
            </Toolbar>
        </AppBar>
    )
}
